import { render } from "./navigationBar.vue?vue&type=template&id=2095616b"
import script from "./navigationBar.vue?vue&type=script&lang=js"
export * from "./navigationBar.vue?vue&type=script&lang=js"

import "./navigationBar.vue?vue&type=style&index=0&id=2095616b&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__